import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useWindowScroll } from 'react-use'

import { ButtonClose, Modal } from '@/generic'
import { trackNewsletterPopupOpens } from '@/tracking'

export const NewsletterSubscriptionPopup = ({ iframeHeight, iframeUrl, formName, markNewsletterSeen }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isReported, setIsReported] = useState(false)
  const { y: scrollY } = useWindowScroll()
  const onClose = useCallback(() => {
    setIsOpen(false)
    markNewsletterSeen()
  }, [markNewsletterSeen])

  useEffect(() => {
    const halfHeight = (document.body.offsetHeight - window.innerHeight) / 2
    if (scrollY >= halfHeight) {
      setIsOpen(true)
    }
  }, [scrollY])

  useEffect(() => {
    if (isOpen && !isReported) {
      trackNewsletterPopupOpens(formName)
      setIsReported(true)
    }
  }, [isOpen, isReported, formName])

  return (
    <Modal isOpen={isOpen} toggle={onClose} className='qa-cms-nl' modalClassName='qa-cms-nl-overlay'>
      <ButtonClose onClick={onClose} className='newsletter-close qa-cms-nl-close' />
      <iframe
        src={iframeUrl}
        frameBorder='0'
        width='100%'
        height={iframeHeight}
      />
    </Modal>
  )
}

NewsletterSubscriptionPopup.propTypes = {
  iframeUrl: PropTypes.string.isRequired,
  iframeHeight: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  markNewsletterSeen: PropTypes.func.isRequired
}

export default NewsletterSubscriptionPopup
